
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';
import { Capacitor } from '@capacitor/core';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { toast } = useToast();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        console.log('AuthCallback: Processing authentication callback...');
        console.log('AuthCallback: Current URL:', window.location.href);
        
        // Get the URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const hashParams = new URLSearchParams(window.location.hash.substring(1));
        
        // Check for access token in hash (for email verification)
        const accessToken = hashParams.get('access_token');
        const refreshToken = hashParams.get('refresh_token');
        const type = hashParams.get('type');
        
        console.log('AuthCallback: Tokens found:', { 
          hasAccessToken: !!accessToken, 
          hasRefreshToken: !!refreshToken, 
          type 
        });
        
        // Check for error
        const error = urlParams.get('error') || hashParams.get('error');
        const errorDescription = urlParams.get('error_description') || hashParams.get('error_description');
        
        if (error) {
          console.error('Auth callback error:', error, errorDescription);
          toast({
            title: "Authentication Error",
            description: errorDescription || error,
            variant: "destructive",
          });
          navigate('/auth');
          return;
        }

        // If we have tokens, set the session
        if (accessToken && refreshToken) {
          const { error: sessionError } = await supabase.auth.setSession({
            access_token: accessToken,
            refresh_token: refreshToken,
          });

          if (sessionError) {
            console.error('Session error:', sessionError);
            toast({
              title: "Session Error",
              description: sessionError.message,
              variant: "destructive",
            });
            navigate('/auth');
            return;
          }

          // Handle different types of authentication
          if (type === 'signup') {
            // Don't show toast on native - the Auth page overlay handles this
            if (!Capacitor.isNativePlatform()) {
              toast({
                title: "Email Verified",
                description: "Your email has been verified successfully!",
              });
            }
          } else if (type === 'recovery') {
            toast({
              title: "Password Reset",
              description: "You can now set a new password.",
            });
            navigate('/reset-password');
            return;
          }

          // Redirect to home page
          navigate('/');
        } else {
          // No tokens found, redirect to auth
          navigate('/auth');
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        toast({
          title: "Authentication Error",
          description: "An error occurred during authentication.",
          variant: "destructive",
        });
        navigate('/auth');
      }
    };

    handleAuthCallback();
  }, [navigate, toast]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto mb-4"></div>
        <p>Processing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
